/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { 
  styled, 
  Link, 
  Typography,
  Button,
  Select,
  InputLabel,
} from "@mui/material";

export const RestaurantPageContainer = styled('div')({
  width: '100%',
  overflowX: 'hidden',
})

export const StyledBreadCrumbContainer = styled('div')({
  height: '20px',
  width: '100%',
  backgroundColor: '#f5f5f8',
  padding: '10px 0px 10px 20px',
  borderColor: '#e0e0e0',
  borderWidth: '0px 0px 1px 0px',
  borderStyle: 'solid',
})

export const StyledLink = styled(Link)(({ color }) => ({
  textDecoration: 'none',
  color: color,
  fontSize: '13px',
  fontWeight: '400',
}))

export const StyledTitleContainer = styled('div')({
  padding: '20px 0px 10px 0px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

export const StyledTitle = styled(Typography)({
  fontSize: '24px',
  fontWeight: '700',
  lineHeight: '40px',
})

export const StyledButton = styled(Button)({
  textTransform: 'none',
  fontWeight: '600',
  boxShadow: 'none',
})

export const StyledSelect = styled(Select)({
  '&:hover':{
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: '#395bbd',
    }
  },
  '&.MuiInputBase-root': {
    height: '36px !important',
  }
})

export const StyledInputLabel = styled(InputLabel)({
    fontSize: '14px',
})
